import { Phone, MessageCircle, MapPin, Clock, ChevronRight } from 'lucide-react';
import { communes } from '@/mocks/communes';

export function Footer() {
  const primaryCommunes = communes.slice(0, 10);

  return (
    <footer className="bg-primary-500 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="mb-10 pb-8 border-b border-white/10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <img src="/logo-blanc.svg" alt="Volet Charleroi" width="230" height="44" className="h-10 w-auto" />
          <a href="tel:+3280020410" className="inline-flex items-center gap-2 text-lg font-heading font-bold text-white hover:text-accent-400 transition-colors">
            <Phone className="w-5 h-5" /> 0800 20 410
          </a>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Prestations */}
          <div>
            <h4 className="font-heading font-semibold text-base mb-4">
              <span className="text-accent-400">Nos prestations</span>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/nos-prestations/#volet-bloque" className="text-sm text-white/75 hover:text-accent-400 transition-colors">
                  Volet bloqué
                </Link>
              </li>
              <li>
                <Link to="/nos-prestations/#moteur-hs" className="text-sm text-white/75 hover:text-accent-400 transition-colors">
                  Moteur HS
                </Link>
              </li>
              <li>
                <Link to="/nos-prestations/#sangle-cassee" className="text-sm text-white/75 hover:text-accent-400 transition-colors">
                  Sangle ou manivelle cassée
                </Link>
              </li>
              <li>
                <Link to="/nos-prestations/#telecommande-hs" className="text-sm text-white/75 hover:text-accent-400 transition-colors">
                  Télécommande HS
                </Link>
              </li>
              <li>
                <Link to="/nos-prestations/#lames-abimees" className="text-sm text-white/75 hover:text-accent-400 transition-colors">
                  Lames ou tablier abîmés
                </Link>
              </li>
              <li>
                <Link to="/motorisation-volet-charleroi/" className="text-sm text-white/75 hover:text-accent-400 transition-colors">
                  Motorisation
                </Link>
              </li>
            </ul>
          </div>

          {/* Zones */}
          <div>
            <h4 className="font-heading font-semibold text-base mb-4">
              <span className="text-accent-400">Zones d'intervention</span>
            </h4>
            <ul className="space-y-2.5">
              {primaryCommunes.map((commune) => (
                <li key={commune.slug}>
                  <Link
                    to={commune.urlPath}
                    className="text-sm text-white/75 hover:text-accent-400 transition-colors"
                  >
                    {commune.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/zones-dinterventions/"
                  className="inline-flex items-center gap-1 text-sm text-accent-400 hover:text-accent-300 transition-colors"
                >
                  Toutes les communes
                  <ChevronRight className="w-3.5 h-3.5" />
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-semibold text-base mb-4">
              <span className="text-accent-400">Contact</span>
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="tel:+3280020410"
                  className="inline-flex items-center gap-2 text-sm text-white/75 hover:text-accent-400 transition-colors"
                >
                  <Phone className="w-4 h-4 shrink-0" />
                  <span>0800 20 410</span>
                </a>
              </li>
              <li>
                <a
                  href="https://wa.me/32475585219"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-sm text-white/75 hover:text-accent-400 transition-colors"
                >
                  <MessageCircle className="w-4 h-4 shrink-0" />
                  <span>+32 475 58 52 19</span>
                </a>
              </li>
              <li>
                <a
                  href="mailto:info@volet-charleroi.be"
                  className="inline-flex items-center gap-2 text-sm text-white/75 hover:text-accent-400 transition-colors break-all"
                >
                  info@volet-charleroi.be
                </a>
              </li>
              <li className="flex items-start gap-2 text-sm text-white/75">
                <MapPin className="w-4 h-4 shrink-0 mt-0.5" />
                <span>6000 Charleroi</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-white/75">
                <Clock className="w-4 h-4 shrink-0 mt-0.5" />
                <span>
                  Lun-Jeu 8h-19h<br />
                  Ven & Sam 8h-12h
                </span>
              </li>
            </ul>
          </div>

          {/* Informations légales */}
          <div>
            <h4 className="font-heading font-semibold text-base mb-4">
              <span className="text-accent-400">Informations</span>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/qui-sommes-nous/" className="text-sm text-white/75 hover:text-accent-400 transition-colors">
                  Qui sommes-nous
                </Link>
              </li>
              <li>
                <Link to="/contact/" className="text-sm text-white/75 hover:text-accent-400 transition-colors">
                  Demander un devis
                </Link>
              </li>
              <li>
                <Link to="/mentions-legales/" className="text-sm text-white/75 hover:text-accent-400 transition-colors">
                  Mentions légales
                </Link>
              </li>
              <li>
                <Link to="/politique-confidentialite/" className="text-sm text-white/75 hover:text-accent-400 transition-colors">
                  Politique de confidentialité
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-white/50">
            © {new Date().getFullYear()} Volet Charleroi — Réparation & Dépannage de volets roulants à Charleroi et dans le Hainaut
          </p>
          <p className="text-xs text-white/50">
            Garantie 10 ans sur toutes nos interventions
          </p>
        </div>
      </div>
    </footer>
  );
}